import { environment } from 'src/environments/environment';
import { GallerySettingsService } from './../../../services/gallery-settings/gallery-settings.service';
import { SubSink } from 'subsink';
import { ModalController, ToastController } from '@ionic/angular';
import { PlatformService } from './../../../services/platform/platform.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gallery-settings',
  templateUrl: './gallery-settings.page.html',
  styleUrls: ['./gallery-settings.page.scss'],
})
export class GallerySettingsPage implements OnInit {
  s3_url: string = environment.s3_bucket_url;

  isMobileDevice: boolean;
  galleryInfoForm: FormGroup;
  subscription = new SubSink();
  isCreate: boolean = true;

  showSpinner: boolean = false;

  isImage: boolean = true;
  is_not_image_message = '';

  response_message: string = '';
  hasResponseError: boolean = false;

  gallery_image_1_preview: string;
  gallery_image_2_preview: string;
  gallery_image_3_preview: string;
  gallery_image_4_preview: string;
  gallery_image_5_preview: string;
  gallery_image_6_preview: string;

  constructor(
    private fb: FormBuilder,
    private platform: PlatformService,
    private modalCtrl: ModalController,
    private toast: ToastController,
    private galleryService: GallerySettingsService
  ) {
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    this.readyGalleryInfoForm();
    this.getGalleryInfoData();
  }

  readyGalleryInfoForm() {
    this.galleryInfoForm = this.fb.group({
      gallery_image_1: File,
      gallery_image_2: File,
      gallery_image_3: File,
      gallery_image_4: File,
      gallery_image_5: File,
      gallery_image_6: File,
    });
  }

  get gallery_image_1() {
    return this.galleryInfoForm.get('gallery_image_1');
  }

  get gallery_image_2() {
    return this.galleryInfoForm.get('gallery_image_2');
  }

  get gallery_image_3() {
    return this.galleryInfoForm.get('gallery_image_3');
  }

  get gallery_image_4() {
    return this.galleryInfoForm.get('gallery_image_4');
  }

  get gallery_image_5() {
    return this.galleryInfoForm.get('gallery_image_5');
  }

  get gallery_image_6() {
    return this.galleryInfoForm.get('gallery_image_6');
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  readyFormData(res: any) {
    res.forEach((element) => {
      if (element.image_type === 'gallery_image_1') {
        this.gallery_image_1_preview = element?.s3_uid
          ? this.s3_url + element.s3_uid
          : null;
      } else if (element.image_type === 'gallery_image_2') {
        this.gallery_image_2_preview = element?.s3_uid
          ? this.s3_url + element.s3_uid
          : null;
      } else if (element.image_type === 'gallery_image_3') {
        this.gallery_image_3_preview = element?.s3_uid
          ? this.s3_url + element.s3_uid
          : null;
      } else if (element.image_type === 'gallery_image_4') {
        this.gallery_image_4_preview = element?.s3_uid
          ? this.s3_url + element.s3_uid
          : null;
      } else if (element.image_type === 'gallery_image_5') {
        this.gallery_image_5_preview = element?.s3_uid
          ? this.s3_url + element.s3_uid
          : null;
      } else if (element.image_type === 'gallery_image_6') {
        this.gallery_image_6_preview = element?.s3_uid
          ? this.s3_url + element.s3_uid
          : null;
      }
    });
    if (res?.status === undefined) {
      this.isCreate = false;
    }
  }

  uploadImage(event: any, identifier: string) {
    if (
      event.target.files &&
      event.target.files[0] &&
      event.target.files[0].type.includes('image/')
    ) {
      const reader = new FileReader();

      reader.onload = (_event: any) => {
        if (identifier === 'gallery_image_1') {
          this.gallery_image_1_preview = _event.target.result;
        } else if (identifier === 'gallery_image_2') {
          this.gallery_image_2_preview = _event.target.result;
        } else if (identifier === 'gallery_image_3') {
          this.gallery_image_3_preview = _event.target.result;
        } else if (identifier === 'gallery_image_4') {
          this.gallery_image_4_preview = _event.target.result;
        } else if (identifier === 'gallery_image_5') {
          this.gallery_image_5_preview = _event.target.result;
        } else if (identifier === 'gallery_image_6') {
          this.gallery_image_6_preview = _event.target.result;
        }

        this.isImage= true;

        this.galleryInfoForm
          .get(`${identifier}`)
          ?.setValue(event.target.files[0]);
        if (identifier === 'gallery_image_1') {
          this.gallery_image_1.markAsDirty();
        } else if (identifier === 'gallery_image_2') {
          this.gallery_image_2.markAsDirty();
        } else if (identifier === 'gallery_image_3') {
          this.gallery_image_3.markAsDirty();
        } else if (identifier === 'gallery_image_4') {
          this.gallery_image_4.markAsDirty();
        } else if (identifier === 'gallery_image_5') {
          this.gallery_image_5.markAsDirty();
        } else if (identifier === 'gallery_image_6') {
          this.gallery_image_6.markAsDirty();
        }
        // console.log(
        //   `${identifier} data --------> `,
        //   this.galleryInfoForm.get(`${identifier}`).value
        // );
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.galleryInfoForm.markAsPristine();
      this.isImage = false;
      if (identifier === 'gallery_image_1') {
        this.gallery_image_1_preview = null;
      } else if (identifier === 'gallery_image_2') {
        this.gallery_image_2_preview = null;
      } else if (identifier === 'gallery_image_3') {
        this.gallery_image_3_preview = null;
      } else if (identifier === 'gallery_image_4') {
        this.gallery_image_4_preview = null;
      } else if (identifier === 'gallery_image_5') {
        this.gallery_image_5_preview = null;
      } else if (identifier === 'gallery_image_6') {
        this.gallery_image_6_preview = null;
      }
      this.galleryInfoForm.get(`${identifier}`)?.setValue(null);
      if (event.target.files[0] === undefined)
        this.is_not_image_message = "No image file selected";
      else
        this.is_not_image_message = "Only Image files can be uploaded";
    }
  }

  getGalleryInfoData() {
    this.subscription.sink = this.galleryService.getGalleryInfo().subscribe(
      (res_galleryInfo: any) => {
        this.readyFormData(res_galleryInfo);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  updateGalleryInfo() {
    this.showSpinner = true;
    let galleryFormInfo = this.galleryInfoForm.value;
    // console.log('Gallery info -------> ', galleryFormInfo);
    var galleryInfo: FormData = new FormData();
    galleryInfo.append('gallery_image_1', galleryFormInfo?.gallery_image_1);
    galleryInfo.append('gallery_image_2', galleryFormInfo?.gallery_image_2);
    galleryInfo.append('gallery_image_3', galleryFormInfo?.gallery_image_3);
    galleryInfo.append('gallery_image_4', galleryFormInfo?.gallery_image_4);
    galleryInfo.append('gallery_image_5', galleryFormInfo?.gallery_image_5);
    galleryInfo.append('gallery_image_6', galleryFormInfo?.gallery_image_6);

    // console.log('Gallery info after -------> ', galleryInfo);
    if (this.isCreate) {
      this.subscription.sink = this.galleryService
        .createGalleryInfo(galleryInfo)
        .subscribe(
          (res: any) => {
            this.isCreate = false;
            this.showSpinner = false;
            // console.log('create gallery response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);
          },
          (err: any) => {
            this.showSpinner = false;
            // console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred adding your Gallery images, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
    } else {
      // console.log('latest gallery info -----------> ', galleryInfo);
      this.subscription.sink = this.galleryService
        .updateGalleryInfo(galleryInfo)
        .subscribe(
          (res: any) => {
            this.showSpinner = false;
            // console.log('update gallery response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);
          },
          (err: any) => {
            this.showSpinner = false;
            // console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred updating your Gallery images, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
    }
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  closeModal() {
    return this.modalCtrl.dismiss();
  }
}
